import { CONTAINER_CONTAINER, DIALOG_SIZE } from "src/libs/interfaces/layouts"
import { ILanding, ILandingSection } from "../../../data/interfaces"
import { useEffect, useState } from "react"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"

/* Protopia Ecosystem component */
export interface IContainerProps {
    section: ILandingSection
    i: number
    children: JSX.Element | JSX.Element[]
}
const Container = (props: IContainerProps): JSX.Element => {
    const [section, setSection] = useState<ILandingSection>(props.section)
    useEffect(() => {
        const unsubscribe = useLandingStore.subscribe(
            ( state: ILandingStore ) => state.currentLanding,
            ( currentLanding:ILanding ) => { 
                const sec: ILandingSection = currentLanding.sections[ props.i ]
                            
                if( JSON.stringify( sec ) !== JSON.stringify( section ) ) { 
                    setSection(() => {
                        return sec
                    })
                }
            }, 
            {} 
        )
        return () => {
            unsubscribe();
        };
    }, [])

    return <div className={ `landing-section-container ${getContainerClass( props.section.composition?.container )} ` } > 
        { props.children }
    </div>
}
export default Container

export const getContainerClass = ( container: DIALOG_SIZE | undefined ) => {
    return CONTAINER_CONTAINER[container || DIALOG_SIZE.NORMAL] 
}